
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unidades-licenciadas",
      function () {
        return require("private-next-pages/unidades-licenciadas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unidades-licenciadas"])
      });
    }
  